import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from '../config/axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { phoneFormat, validRegex } from "../helper/helper";
export const fetchContext = createAsyncThunk("fetchContextData", async (arg, { rejectWithValue }) => {
    try {
        const { data } = await axios.post('/playgroundController/getdefaultcontext', arg, {
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        return data;
    } catch (error) {
        rejectWithValue(error);
    }
});

export const postContext = createAsyncThunk("postContextData", async (arg, { rejectWithValue }) => {
    console.log(arg);
    try {
        const { data } = await axios.post('/playgroundController/savePlayground', arg, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return data;
    } catch (error) {
        rejectWithValue(error);
    }
})

const initialState = {
    contextData: null,
    loading: false,
    message: '',
    isSuccess: false,
    isFaqQueAdded: false,
    isPhoneValid: false,
    isEmailValid: false,
    selectedCategory: [],
    selectedSubCategory: [],
    additionalCategory: '',
    subcategoryListByCategory: [],
    playgroundId: '',
    playgroundUniqueId: '',
    defaultconversation_goal:'',
    displayUrl: false,
    errors: {},
    mainloading: true,
    defaultScrappedData: null,
    selectTemplate: '',
    selectTemplateList: [
        {
            id: 1,
            value: '',
            name: 'Select a template',
            isSelected: false,
        },
        {
            id: 2,
            value: 'zy642dc7c895b6b',
            name: 'Plumbing / HVAC',
            isSelected: false,
        },
        {
            id: 3,
            value: 'zy6424b8f764141',
            name: 'Dental',
            isSelected: false,
        },
        {
            id: 4,
            value: 'zy64370a6e9414e',
            name: 'Legal',
            isSelected: false,
        },
    ]
}

export const appSlice = createSlice({
    name: 'appdata',
    initialState,
    reducers: {
        onChangeSelectTemplate: (state, { payload }) => {
            const selectTemplateList = JSON.parse(JSON.stringify(state.selectTemplateList));
            // find index
            const optionIndex = selectTemplateList.findIndex((item) => item.value == payload);
            if (optionIndex != -1) {
                selectTemplateList[optionIndex].isSelected = true;
            }
            state.selectTemplateList = selectTemplateList;
            state.selectTemplate = payload;
        },
        onAddCompanyOverview: (state, { payload }) => {
            if (typeof payload === 'object' && payload[1] === 'scrapped') {
                const defaultContext = JSON.parse(JSON.stringify(state.defaultScrappedData));
                defaultContext.company_overview = payload;
                state.contextData = defaultContext;
                state.playgroundId = '';
                state.playgroundUniqueId = '';
                state.selectTemplate = '';
            } else {
                state.contextData.company_overview = payload;
            }

        },
        onGenerateShareUrl: (state, { payload }) => {
            state.displayUrl = payload;
        },
        addAboutUs: (state, { payload }) => {
            const aboutUsInputs = JSON.parse(JSON.stringify(state.contextData.about_us));
            aboutUsInputs[payload[1]].a = payload[0];
            state.contextData.about_us = aboutUsInputs;
        },
        addFaqQuestion: (state, { payload }) => {
            if (payload !== '') {
                const faqdata = JSON.parse(JSON.stringify(state.contextData.your_faq));
                console.log(faqdata, 'faqdata')
                const newQ = {
                    q: payload,
                    a: ''
                }
                faqdata.push(newQ);
                state.contextData.your_faq = faqdata;
                state.isFaqQueAdded = true;
            }
        },

        addFaqAnswer: (state, { payload }) => {
            const faqInputs = JSON.parse(JSON.stringify(state?.contextData?.your_faq));
            if (faqInputs && faqInputs[payload[1]]) {
                faqInputs[payload[1]].a = payload[0];
                state.contextData.your_faq = faqInputs;
            }
        },
        resetFaq:(state, { payload }) => {
                state.contextData.your_faq = [];
                state.contextData.conversation_goal = state.defaultconversation_goal;
               
        },

        addFaqAnswerFromScrapped: (state, { payload }) => {
            const faqInputs = JSON.parse(JSON.stringify(state?.contextData?.your_faq));
            const scrappedFaq = payload || []?.map((question) => {
                return { q: question, a: question?.a || '' };
            });
            const updatedFaqList = [...faqInputs, ...scrappedFaq];
            state.contextData.your_faq = updatedFaqList;
        },


        onchangeAdditionFaqContext: (state, { payload }) => {
            console.log("dd", payload);
            state.contextData.additonal_faq_context = payload;
        },
        addConversation: (state, { payload }) => {
            if (payload !== '') {
                state.contextData.conversation_goal = payload;
            }
        },
        addCompanyInfo: (state, { payload }) => {
            if (payload[1] !== '') {
                if (payload[1] === 'phoneNumber') {
                    let phonenum = payload[0];
                    if (phonenum.startsWith('(') && phonenum.length === 4) {
                        phonenum = phonenum.slice(0, (phonenum.length - 1));
                    }
                    payload[0] = phoneFormat(phonenum);
                }

                if (payload[1] === 'email') {
                    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(payload[0])) {
                        state.isEmailValid = false;
                    } else {
                        state.isEmailValid = true;
                    }
                }
                state.contextData.company_information[payload[1]] = payload[0]
            }
        },
        onSelectCategory: (state, { payload }) => {
            let catData = JSON.parse(JSON.stringify(state.selectedCategory));

            // main category by user
            let maincat = JSON.parse(JSON.stringify(state.contextData.business_categories.mainCatSelected));

            // for main subcategory
            let subcat = JSON.parse(JSON.stringify(state.contextData.business_categories.subCatDeata));

            // admin business category
            const categories = JSON.parse(JSON.stringify(state.contextData.categories));

            // admin business category
            const subCategories = JSON.parse(JSON.stringify(state.contextData.subCategories));

            // add or remove category id in selected category state
            const checkIndex = catData.findIndex((v, i) => v == payload[0]);
            console.log('checking index', checkIndex);
            if (checkIndex === -1) {
                catData.push(payload[0]);
            } else {
                catData.splice(checkIndex, 1);
            }
            state.selectedCategory = catData;

            // add or remove main category in contextdata 
            //get category by id from gpt main category
            const getCat = categories.filter((cat) => cat.id === payload[0]);
            if (Array.isArray(getCat) && getCat.length) {
                // check if this category is in user selected main category and if exist then remove and if not exist then add
                const checkindex = maincat.findIndex((cat, i) => cat.id === payload[0]);
                if (checkindex !== -1) {
                    // removing category
                    maincat.splice(checkindex, 1);
                } else {
                    // adding new category
                    maincat = [...maincat, ...getCat]
                }
            }
            // set maincat to state
            state.contextData.business_categories.mainCatSelected = maincat;

            // get sub category selected
            let userSelectedsubCategories = JSON.parse(JSON.stringify(state.subcategoryListByCategory));
            if (payload[1]) {
                let serviceData = subCategories.filter((item) => item.cat_id == payload[0]);
                userSelectedsubCategories = [...userSelectedsubCategories, ...serviceData];
            } else {
                userSelectedsubCategories = userSelectedsubCategories.filter((item) => item.cat_id != payload[0]);
            }

            state.subcategoryListByCategory = userSelectedsubCategories;

            if (!payload[1]) {
                const removeSubCategoryForThisCat = subcat.filter((item) => item.cat_id != payload[0]);
                state.contextData.business_categories.subCatDeata = removeSubCategoryForThisCat;
            }

        },
        onSelectSubCategory: (state, { payload }) => {
            // const subCategories = JSON.parse(JSON.stringify(state.contextData.subCategories));
            let userSelectedsubCategories = JSON.parse(JSON.stringify(state.subcategoryListByCategory));
            const checkindex = userSelectedsubCategories.findIndex((cat, i) => cat.id == payload[0]);
            if (checkindex !== -1) {
                if (userSelectedsubCategories[checkindex].hasOwnProperty('checked')) {
                    userSelectedsubCategories[checkindex].checked = !userSelectedsubCategories[checkindex].checked;
                } else {
                    userSelectedsubCategories[checkindex].checked = true;
                }
                userSelectedsubCategories[checkindex].excludedServices = '';
            }
            state.subcategoryListByCategory = userSelectedsubCategories;

            // updating business sub category 
            const allsubsel = userSelectedsubCategories.filter((item) => item.checked)
            state.contextData.business_categories.subCatDeata = allsubsel;
        },
        onChangeAdditionalCategory: (state, { payload }) => {
            state.contextData.business_categories.additionCategories = payload;
        },
        onChangeExcludedService: (state, { payload }) => {
            let userSelectedsubCategories = JSON.parse(JSON.stringify(state.subcategoryListByCategory));
            const checkindex = userSelectedsubCategories.findIndex((cat, i) => cat.id == payload[0]);
            if (checkindex !== -1) {
                userSelectedsubCategories[checkindex].excludedServices = payload[1];
            }
            state.subcategoryListByCategory = userSelectedsubCategories;

            // for main subcategory
            let subcat = JSON.parse(JSON.stringify(state.contextData.business_categories.subCatDeata));
            const checkindexsubcat = subcat.findIndex((cat, i) => cat.id == payload[0]);
            if (checkindexsubcat !== -1) {
                subcat[checkindexsubcat].excludedServices = payload[1];
            }
            state.contextData.business_categories.subCatDeata = subcat;
        },
        onAddZipCodeLocation: (state, { payload }) => {
            const zipcoderule = {
                'zipcode': '',
                'willing_travel': '',
                'lat': '',
                'lng': ''
            };

            let zipCodeState = JSON.parse(JSON.stringify(state.contextData.zipcoderules));
            zipCodeState.push(zipcoderule);
            state.contextData.zipcoderules = zipCodeState;
        },
        onDeleteLocation: (state, { payload }) => {
            let zipCodeState = JSON.parse(JSON.stringify(state.contextData.zipcoderules));
            zipCodeState.splice(payload, 1);
            state.contextData.zipcoderules = zipCodeState;
        },
        onAddInputLocation: (state, { payload }) => {
            let zipCodeState = JSON.parse(JSON.stringify(state.contextData.zipcoderules));
            if (payload[2] === 'zipcode') {
                zipCodeState[payload[1]].zipcode = payload[0];
            }

            if (payload[2] === 'willing') {
                zipCodeState[payload[1]].willing_travel = payload[0];
            }
            state.contextData.zipcoderules = zipCodeState;
        },
        onaddExtraColor: (state, { payload }) => {
            if (payload === 'header') {
                let buttonHeaderColor = JSON.parse(JSON.stringify(state.contextData.buttonHeaderColor));
                buttonHeaderColor.push('#ffffff');
                state.contextData.buttonHeaderColor = buttonHeaderColor;
            }
            if (payload === 'button') {
                let buttonColor = JSON.parse(JSON.stringify(state.contextData.buttonColor));
                buttonColor.push('#ffffff');
                state.contextData.buttonColor = buttonColor;
            }
        },
        deleteExtraColor: (state, { payload }) => {
            if (payload[1] === 'header') {
                let buttonHeaderColor = JSON.parse(JSON.stringify(state.contextData.buttonHeaderColor));
                buttonHeaderColor.splice(payload[0], 1);
                state.contextData.buttonHeaderColor = buttonHeaderColor;
            }
            if (payload[1] === 'button') {
                let buttonColor = JSON.parse(JSON.stringify(state.contextData.buttonColor));
                buttonColor.splice(payload[0], 1);
                state.contextData.buttonColor = buttonColor;
            }
        },
        onUpdateExtraColor: (state, { payload }) => {
            if (payload[0] === 'buttonHeaderColor') {
                let buttonHeaderColor = JSON.parse(JSON.stringify(state.contextData.buttonHeaderColor));
                buttonHeaderColor[payload[1]] = payload[2]
                state.contextData.buttonHeaderColor = buttonHeaderColor;
            }
            if (payload[0] === 'primaryColor') {
                state.contextData.primaryColor = payload[1];
            }
            if (payload[0] === 'secondaryColor') {
                state.contextData.secondaryColor = payload[1];
            }
            if (payload[0] === 'buttonTextColor') {
                state.contextData.buttonTextColor = payload[1];
            }
            if (payload[0] === 'buttonColor') {
                let buttonColor = JSON.parse(JSON.stringify(state.contextData.buttonColor));

                buttonColor[payload[1]] = payload[2]
                state.contextData.buttonColor = buttonColor;
            }
        },
        onchangeChatIcon: (state, { payload }) => {
            state.contextData.selectedTheme = payload;
        },
        handleCompanyLogo: (state, { payload }) => {
            let errList = JSON.parse(JSON.stringify(state.errors));
            let imageMIME = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];

            if (imageMIME.includes(payload.target.files[0].type) == true && payload.target.files[0].type != '') {
                delete errList['companyLogo'];
                state.errors = errList;
                state.contextData.companyLogo = URL.createObjectURL(payload.target.files[0])
            } else {
                errList['companyLogo'] = 'Invalid file format. Only "jpg, jpeg, png, gif" files are supported.';
                state.errors = errList;
                toast.error(errList['companyLogo'], {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }

        },
        handleCompanyLogoRemove: (state, { payload }) => {
            state.contextData.companyLogo = ''
        }
    },
    extraReducers: {
        [fetchContext.pending]: (state, { payload }) => {
            state.loading = true;
            state.mainloading = true;
        },
        [fetchContext.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.isSuccess = true;
            state.mainloading = false;
            const payloaddata = payload;
            if (Object.keys(payloaddata).length) {
                // if (payloaddata.id) {
                //     state.playgroundId = payloaddata.id;
                // }
                state.playgroundId = payloaddata.id ? payloaddata.id : '';
                state.playgroundUniqueId = payloaddata.playground_id;
                state.defaultconversation_goal=payload.conversation_goal ? payload.conversation_goal : '';
                payloaddata.company_information = (typeof payloaddata.company_information === 'string') ? JSON.parse(payloaddata.company_information) : payloaddata.company_information;

                // business category
                payloaddata.business_categories = (typeof payloaddata.business_categories === 'string') ? JSON.parse(payloaddata.business_categories) : payloaddata.business_categories;

                let selid = [];
                // getting all selcted main category into selid
                if (payloaddata.business_categories.mainCatSelected.length) {
                    selid = payloaddata.business_categories.mainCatSelected.map((item) => { return item.id });
                    state.selectedCategory = selid;
                }

                const subCategories = payloaddata.subCategories;

                let subByCat = [];
                // all subcategory for selcted main category into subByCat
                if (selid.length) {
                    subByCat = subCategories.filter((item) => selid.includes(item.cat_id));
                }
                let checksub = {};
                if (payloaddata.business_categories.subCatDeata.length) {
                    // create a array with selected subcategory in checksub
                    payloaddata.business_categories.subCatDeata.forEach((item, i) => {
                        checksub[item.id] = i;
                    });
                    // if cheksub has elements then update subcategoryListByCategory state with checked subcategory
                    console.log('checksub', subByCat, Object.keys(checksub), checksub);
                    const allkeys = Object.keys(checksub);
                    if (allkeys.length) {
                        subByCat.forEach((item, i) => {
                            if (allkeys.includes(item.id)) {
                                subByCat[i].checked = payloaddata.business_categories.subCatDeata[checksub[item.id]].checked;
                                subByCat[i].excludedServices = payloaddata.business_categories.subCatDeata[checksub[item.id]].excludedServices;
                            }
                        })
                    }
                    state.subcategoryListByCategory = subByCat;
                } else {
                    state.subcategoryListByCategory = subByCat;
                }

                // about us
                payloaddata.about_us = (typeof payloaddata.about_us === 'string') ? JSON.parse(payloaddata.about_us) : payloaddata.about_us;


                // zipcode
                payloaddata.zipcoderules = (typeof payloaddata.zipcoderules === 'string') ? JSON.parse(payloaddata.zipcoderules) : payloaddata.zipcoderules;

                // your faqa
                payloaddata.your_faq = (typeof payloaddata.your_faq === 'string') ? JSON.parse(payloaddata.your_faq) : payloaddata.your_faq;
                state.contextData = payloaddata;
                if (!payloaddata.hasOwnProperty('id')) {
                    state.defaultScrappedData = payloaddata;
                }
            } else {
                toast.error('Something went wrong', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }


        },
        [fetchContext.rejected]: (state, { payload }) => {
            state.message = payload;
            state.loading = false;
            state.isSuccess = false;
        },

        [postContext.pending]: (state, { payload }) => {
            state.loading = true
        },
        [postContext.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.isSuccess = true;

            const payloaddata = payload;

            state.playgroundId = payload.pbid ? payload.pbid : '';

            state.playgroundUniqueId = payload.playground ? payload.playground : '';
            state.message = payload.message;
        },
        [postContext.rejected]: (state, { payload }) => {
            state.message = payload;
            state.loading = false;
            state.isSuccess = false;
        },
    }
});

// Action creators are generated for each case reducer function
export const { addFaqQuestion, addConversation, addCompanyInfo, addFaqAnswer, addAboutUs, onSelectCategory, onchangeAdditionFaqContext, onSelectSubCategory, onChangeAdditionalCategory, onChangeExcludedService, onAddZipCodeLocation, onDeleteLocation, onAddInputLocation, onaddExtraColor, deleteExtraColor, onUpdateExtraColor, onchangeChatIcon, handleCompanyLogo, handleCompanyLogoRemove, onGenerateShareUrl, onAddCompanyOverview, addFaqAnswerFromScrapped, onChangeSelectTemplate,resetFaq } = appSlice.actions

export default appSlice.reducer